export default [
  {
    path: '/hotpoint',
    name: 'hotpoint',
    meta: {
      title: '批量热点'
    },
    component: () => import (/* webpackChunkName: "example-eventlist" */ '../views/hotpoint/index.vue')
  }
]